import type { SelectChangeEvent, Theme } from "@mui/material";
import { FormControl, InputLabel, MenuItem, Select, useTheme } from "@mui/material";
import type { FC } from "react";
import { OrderStatus } from "../../data/BaseEntity";
import { orderStatusToName } from "./orderStatusToName";

function getStyles(status: OrderStatus, statuses: OrderStatus[], theme: Theme) {
  return {
    fontWeight: statuses.includes(status) ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
  };
}

interface Props {
  readonly values: OrderStatus[];
  readonly fullWidth?: boolean;
  readonly size?: "small" | "medium";
  readonly onChange: (selectedValues: OrderStatus[]) => void;
}

const OrderStatusMultiSelect: FC<Props> = ({ values, fullWidth, size, onChange }) => {
  const theme = useTheme();

  const handleChange = (event: SelectChangeEvent<OrderStatus[]>) => {
    const {
      target: { value },
    } = event;
    onChange(
      // On autofill we get a stringified value.
      typeof value === "string" ? (value.split(",") as OrderStatus[]) : value,
    );
  };

  const labelId = "order-status-select-label";

  return (
    <FormControl variant="outlined" fullWidth={fullWidth} size={size}>
      <InputLabel id={labelId}>Status</InputLabel>
      <Select labelId={labelId} multiple value={values} onChange={handleChange} fullWidth={fullWidth} label="Status">
        {Object.values(OrderStatus).map((s) => (
          <MenuItem key={s} value={s} style={getStyles(s, values, theme)}>
            {orderStatusToName(s)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OrderStatusMultiSelect;
